import { trustMetrics } from "../data/homePageContent";

export function TrustStrip() {
  return (
    <section className="trust-strip" aria-label="Trust metrics">
      <div className="site-shell trust-strip__grid">
        {trustMetrics.map((item) => (
          <div className="trust-item" key={item.value}>
            <div className={item.accent ? "trust-item__value trust-item__value--accent" : "trust-item__value"}>
              {item.value}
            </div>
            <div className="trust-item__label">{item.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
